import { useEffect, useRef, useState } from 'react';
import { DetailCompactTransaction } from '../../../../../types/subscription';
import { CustomTransaction } from 'grts-utils/src/types/Transaction';
import { PriceChartApiResponse } from '../../../../Detail/Charts';
import { Bot } from 'grts-utils/src/types/Bot';
import { TimeFrame } from 'grts-utils/src/types/TimeFrame';
import { CandleSticksLatestOrder } from '../../../../Detail/Charts/types';

import './index.css';
import { ComponentDimensions } from '../../../../../types/Layout';
import CandleSticks from '../../../../../components/Charts/CandleSticks';
import { CandleType } from '../../../../Detail/types';

interface Props {
  rootDimensions: ComponentDimensions | undefined;
  candles: PriceChartApiResponse | undefined;
  bot: Bot;
  timeFrame: TimeFrame | undefined;
  transactions: Array<DetailCompactTransaction | CustomTransaction>;
  isLoading: boolean;
  multiOrderCandles?: PriceChartApiResponse | undefined;
  bundledTransactions: Record<string, DetailCompactTransaction[]>;
  realCompactTransactions: Array<DetailCompactTransaction | CustomTransaction>;
  candleSticksLatestOrder?: CandleSticksLatestOrder;
}

/**
 * We want to show real transactions and profit calc transactions on candles
 * I want to be able to zoomIn on shorter and multi
 *
 * When I press a transaction,
 * I want to see a zoomedIn state from both real and profit calcs transaction
 * (What if one is just completely missing?)
 *
 * What about the different profit calcs from real transactions
 * 1.Take the last one and start at the timestamp of the previous transaction
 * 2. Make sure we do a profit calc for each different complex params found in the transactions
 *
 * We need:
 * The candles to show
 * transaction dots of the real transactions
 * transaction dots of profit calc transactions
 * Feature to handle the press on the transaction
 * Hover shows the transaction info
 */

const TransactionCandles = (props: Props) => {
  const {
    rootDimensions,
    bot,
    timeFrame,
    candles,
    transactions,
    multiOrderCandles,
    bundledTransactions,
    realCompactTransactions,
    isLoading,
    candleSticksLatestOrder,
  } = props;

  /** TODO: feature: control:
   * Every new multiCandle, check the inSync of the real bot and profit calcs */

  /** ============================================== STATES ============================================== */

  /**
   * @TODO
   * I need to filter transactions, the last complex params bundle
   * Because we can't do all of them, yet.
   *
   * We need the specific timeframes of that transaction
   * RIP
   */

  /**
   * @TODO
   * We want to bundle the transactions like this:
   * [
   *   {
   *     [startTimestamp multi candle]: [Transaction, Transaction, ...],
   *     ...
   *   }
   * ]
   *
   * We need to have the multiT candles since the real transaction start
   * And always find the startTimestamp where the transactionTimestamp is between
   * If in the main object the key already exists, push onto the array
   * else create a new one
   *
   * When we fetch our profit calc transactions,
   * the length should always be 2 if they are fully in sync
   */

  /** ============================================== FUNCTIONS ============================================== */

  // const getIndividualTransactions = useCallback(
  //   (compactTransactionId: string | null) => {
  //     const ts = realCompactTransactions;

  //     return (
  //       ts?.filter((t) => t.compactTransactionId === compactTransactionId) ?? []
  //     );
  //   },
  //   [realCompactTransactions],
  // );

  /** ============================================== EFFECTS ============================================== */

  return (
    <div className="detail-transactions-candles-root">
      <CandleSticks
        dimensions={rootDimensions}
        candleResponse={candles}
        bot={bot}
        baseAsset={bot.baseAsset}
        quoteAsset={bot.quoteAsset}
        exchange={bot.defaultExchange}
        timeFrame={timeFrame}
        candleType={CandleType.Heikin}
        isLoading={isLoading}
        transactions={realCompactTransactions}
        transactionsByTimestamp={bundledTransactions}
        multiOrderCandles={multiOrderCandles}
        // getIndividualTransactions={getIndividualTransactions}
        candleSticksLatestOrder={candleSticksLatestOrder}
        scale={'log'}
        useIndicators={false}
      />
    </div>
  );
};

export default TransactionCandles;
